/** @description データ請求時の一回の件数 */
export const PAGE_SIZE: number = 1000
/** @description ソート列 */
export const SORT_COLUMN: string = 'owner_product_name'
/** @description スクロールで底に着いた際に貼る新しいデータの件数 */
export const ONE_TIME_APPEND: number = 50
